<div class="expanded-header-container">
  <div class="expanded-header-container-title">
    <h2>{{ kpi?.name }}</h2>
    <span class="title-divider">|</span>
    <h3>{{ protocolNumber }}</h3>
  </div>

  <div class="expanded-header-container-body">
    <div class="kpi-values-container">
      {{ secondaryValue ?? '--' }}
      <span class="title-divider">|</span>
      {{ (displayValue ?? '') + (displayUnit ?? '') }}
    </div>

    <div *ngIf="kpi" class="trend-indicator-container">
      {{ computeTrendText(kpi.trendText) }}
      <ng-container>
        <kpi-trend-indicator
          class="trend-change-indicator"
          [trendIndicator]="kpi.trendIndicator"
          [trendChange]="kpi.trendChange"
          [kpiType]="kpi.type"
          [kpiName]="kpi.name"
          [showPlaceholder]="true"
        />
      </ng-container>
    </div>

    <div class="kpi-health-container" *ngIf="kpi?.health as health">
      <span> KPI is: </span>
      <status-badge
        [type]="'kpiHealth'"
        [badgeKey]="health"
        class="kpi-health-badge"
      ></status-badge>
    </div>
  </div>
</div>
